export enum Platform {
  OVERVIEW = 'overview',
  GOOGLE = 'google',
  TIKTOK = 'tiktok',
  AMAZON = 'amazon',
  SHOPIFY = 'shopify',
  META = 'meta',
  LINKEDIN = 'linkedin',
  REDDIT = 'reddit',
  BING = 'bing',
  HUBSPOT = 'hubspot',
  X = 'x',
  // The enum VALUE is the logo filename PlatformIcon loads (`/images/openai.svg`).
  OPENAI = 'openai',
}

export const PLATFORM_TITLE: Record<Platform, string> = {
  [Platform.OVERVIEW]: 'Overview',
  [Platform.META]: 'Meta',
  [Platform.GOOGLE]: 'Google',
  [Platform.TIKTOK]: 'TikTok',
  [Platform.AMAZON]: 'Amazon',
  [Platform.SHOPIFY]: 'Shopify',
  [Platform.LINKEDIN]: 'LinkedIn',
  [Platform.REDDIT]: 'Reddit',
  [Platform.BING]: 'Bing Ads',
  [Platform.HUBSPOT]: 'HubSpot',
  [Platform.X]: 'X (Twitter)',
  [Platform.OPENAI]: 'ChatGPT Ads',
};

export const PLATFORM_OPTIONS = (
  Object.keys(Platform) as (keyof typeof Platform)[]
).map((key) => {
  return {
    label: PLATFORM_TITLE[Platform[key]],
    value: Platform[key],
  };
});
